const WET_OPTIONS = [
  {
    label: "No oil in Wet Filter Bowl",
    status: "",
    apiOptionKey: "noOilInWetFilterBowl",
  },
  {
    label: "Oil in bowl found contaminate",
    status: "",
    apiOptionKey: "oilInBowlFoundContaminate",
  },
  {
    label: "Oil level and condition found ok",
    status: "",
    apiOptionKey: "oilLevelAndConditionFoundOk",
  },
];

const DRY_OPTIONS = [
  {
    label: "Found dry and Clean",
    status: "",
    apiOptionKey: "foundDryAndClean",
  },
  {
    label: "Outer element got chocked",
    status: "",
    apiOptionKey: "outerElementGotChocked",
  },
  {
    label: "Inner element got chocked",
    status: "",
    apiOptionKey: "innerElementGotChocked",
  },
  {
    label: "Water Traces observed in filter element",
    status: "",
    apiOptionKey: "waterTracesObservedInFilterElement",
  },
  {
    label: "Oil traces observed in filter element",
    status: "",
    apiOptionKey: "oilTracesObservedInFilterElement",
  },
  {
    label: "Carbon soot observed in filter element",
    status: "",
    apiOptionKey: "carbonSootObservedInFilterElement",
  },
  {
    label: "Outer element found Punctured",
    status: "",
    apiOptionKey: "outerElementFoundPunctured",
  },
  {
    label: "Inner element found Punctured",
    status: "",
    apiOptionKey: "innerElementFoundPunctured",
  },
];

export const getAirFilterQuestions = (details) => {
  if (!details.airFilterType) {
    return [
      {
        label: "Air Filter Type",
        apiKey: "airFilterType",
        type: "RADIO",
        options: [
          { label: "WET", apiOptionKey: "airFilterTypeWet" },
          { label: "DRY", apiOptionKey: "airFilterTypeDry" },
        ],
      },
    ];
  }
  return [
    {
      label: "Air Filter Type",
      apiKey: "airFilterType",
      type: "RADIO",
      options: [
        { label: "WET", apiOptionKey: "airFilterTypeWet" },
        { label: "DRY", apiOptionKey: "airFilterTypeDry" },
      ],
    },
    {
      label: "Condition of Air filter",
      options: details.airFilterType === "WET" ? WET_OPTIONS : DRY_OPTIONS,
    },
    {
      label: "Last oil change date in wet air filter bowl",
      apiKey: "lastOilChangeDateInWetAirFilterBowl",
      type: "DATE",
      options: [],
    },
  ];
};

export const getTurbochargerQuestions = (details) => {
  const Q1 = {
    label: "Turbocharger Engines",
    apiKey: "turboChargerType",
    type: "RADIO",
    options: [
      {
        label: "WITH_INTER_COOLER_ENGINE",
        apiOptionKey: "WITH_INTER_COOLER_ENGINE",
      },
      {
        label: "WITHOUT_INTER_COOLER_ENGINE",
        apiOptionKey: "WITHOUT_INTER_COOLER_ENGINE",
      },
      {
        label: "NATURAL_ASPIRATION_ENGINES",
        apiOptionKey: "NATURAL_ASPIRATION_ENGINES",
      },
    ],
  };
  if (details.turboChargerType === "WITH_INTER_COOLER_ENGINE") {
    return [Q1, ...QUESTIONS_2];
  } else if (details.turboChargerType === "WITHOUT_INTER_COOLER_ENGINE") {
    return [Q1, ...QUESTIONS_3];
  } else if (details.turboChargerType === "NATURAL_ASPIRATION_ENGINES") {
    return [Q1, ...QUESTIONS_4];
  }
  return [Q1];
};

const QUESTIONS_2 = [
  {
    label: "Air filter to Turbocharger Hose Condition",
    options: [
      {
        label: "Found Intact",
        apiOptionKey: "s2q1o1",
        status: "",
      },
      {
        label: "Found Puncture / damage",
        apiOptionKey: "s2q1o2",
        status: "",
      },
      {
        label: "Found clamp loose",
        apiOptionKey: "s2q1o3",
        status: "",
      },
    ],
  },
  {
    label: "Turbocharger to Inter cooler hose condition",
    options: [
      {
        label: "Found Intact",
        apiOptionKey: "s2q2o1",
        status: "",
      },
      {
        label: "Found Puncture / damage",
        apiOptionKey: "s2q2o2",
        status: "",
      },
      {
        label: "Found clamp loose",
        apiOptionKey: "s2q2o3",
        status: "",
      },
    ],
  },
  {
    label: "Intercooler to Inlet Manidold hose condidtion",
    options: [
      {
        label: "Found Intact",
        apiOptionKey: "s2q3o1",
        status: "",
      },
      {
        label: "Found Puncture / damage",
        apiOptionKey: "s2q3o2",
        status: "",
      },
      {
        label: "Found clamp loose",
        apiOptionKey: "s2q3o3",
        status: "",
      },
    ],
  },
  {
    label: "Condition of Turbocharger",
    options: [
      { label: "Found ok", status: "", apiOptionKey: "foundOk" },
      {
        label: "Found Compressor wheel fins damaged",
        status: "",
        apiOptionKey: "s2q4o1",
      },
      {
        label: "Found Turbine wheel fins damaged",
        status: "",
        apiOptionKey: "s2q4o2",
      },
      {
        label: "Found shaft broken",
        status: "",
        apiOptionKey: "s2q4o3",
      },
      {
        label: "Found Oil traces in Compressor end",
        status: "",
        apiOptionKey: "s2q4o4",
      },
      {
        label: "Found Oil Traces in Turbine end",
        status: "",
        apiOptionKey: "s2q4o5",
      },
    ],
  },
  {
    label: "Condition of Inter Cooler",
    options: [
      { label: "Found ok", status: "", apiOptionKey: "foundOkInterCooler" },
      {
        label: "Found Core damaged",
        status: "",
        apiOptionKey: "s2q5o1",
      },
      {
        label: "Found Oil traces in Inter Cooler",
        status: "",
        apiOptionKey: "s2q5o2",
      },
    ],
  },
];

const QUESTIONS_3 = [
  {
    label: "Air filter to Turbocharger Hose Condition",
    options: [
      {
        label: "Found Intact",
        apiOptionKey: "s3q1o1",
        status: "",
      },
      {
        label: "Found Puncture / damage",
        apiOptionKey: "s3q1o2",
        status: "",
      },
      {
        label: "Found clamp loose",
        apiOptionKey: "s3q1o3",
        status: "",
      },
    ],
  },
  {
    label: "Turbocharger to Inlet Manifold hose condition",
    options: [
      {
        label: "Found Intact",
        apiOptionKey: "s3q2o1",
        status: "",
      },
      {
        label: "Found Puncture / damage",
        apiOptionKey: "s3q2o2",
        status: "",
      },
      {
        label: "Found clamp loose",
        apiOptionKey: "s3q2o3",
        status: "",
      },
    ],
  },
  {
    label: "Condition of Turbocharger",
    options: [
      { label: "Found ok", status: "", apiOptionKey: "s3q3o1" },
      {
        label: "Found Compressor wheel fins damaged",
        status: "",
        apiOptionKey: "s3q3o2",
      },
      {
        label: "Found Turbine wheel fins damaged",
        status: "",
        apiOptionKey: "s3q3o3",
      },
      {
        label: "Found shaft broken",
        status: "",
        apiOptionKey: "s3q3o4",
      },
      {
        label: "Found Oil traces in Compressor end",
        status: "",
        apiOptionKey: "s3q3o5",
      },
      {
        label: "Found Oil Traces in Turbine end",
        status: "",
        apiOptionKey: "s3q3o6",
      },
    ],
  },
];

const QUESTIONS_4 = [
  {
    label: "Air filter to Inlet Manifold Hose Condition",
    options: [
      { label: "Found Intact", status: "", apiOptionKey: "s4q1o1" },
      { label: "Found Puncture / damage", status: "", apiOptionKey: "s4q1o2" },
      { label: "Found clamp loose", status: "", apiOptionKey: "s4q1o3" },
    ],
  },
  {
    label: "In Exhaust System",
    options: [
      {
        label: "Oil Wetness observed in Exhaust Manifold",
        status: "",
        apiOptionKey: "s4q2o1",
      },
      {
        label:
          "No Oil / Coolant / Fuel traces Wetness observed in exhaust Manifold",
        status: "",
        apiOptionKey: "s4q2o2",
      },
      {
        label: "Blockage in Silincer tile pipe",
        status: "",
        apiOptionKey: "s4q2o3",
      },
      {
        label: "Coolant Traces observed in Exhaust Manifold",
        status: "",
        apiOptionKey: "s4q2o4",
      },
      {
        label: "Unburnt Fuel coming out from Exhaust Manifold",
        status: "",
        apiOptionKey: "s4q2o5",
      },
      {
        label: "Blockage observed in DOC",
        status: "",
        apiOptionKey: "s4q2o6",
      },
      { label: "Blockage in DPF", status: "", apiOptionKey: "s4q2o7" },
    ],
  },
  {
    label: "In Intake System",
    options: [
      {
        label: "Oil Wetness observed in InInlet Manifold",
        status: "",
        apiOptionKey: "s4q3o1",
      },
      {
        label: "No Oil / Coolant traces Wetness observed in Inlet Manifold",
        status: "",
        apiOptionKey: "s4q3o2",
      },
      {
        label: "Carbon Soot observed in Inlet Manifold",
        status: "",
        apiOptionKey: "s4q3o3",
      },
      {
        label: "Coolant Traces observed in Inlet Manifold",
        status: "",
        apiOptionKey: "s4q3o4",
      },
      {
        label: "Dust observed in Inlet Manifold",
        status: "",
        apiOptionKey: "s4q3o5",
      },
    ],
  },
  {
    label: "EGR Condition",
    options: [
      { label: "Found ok", status: "", apiOptionKey: "s4q4o1" },
      {
        label: "EGR Valve found struck",
        status: "",
        apiOptionKey: "s4q4o2",
      },
    ],
  },
  {
    label: "EGR Cooler Condition",
    options: [
      { label: "Found ok", status: "", apiOptionKey: "s4q5o1" },
      {
        label: "Found Coolant leakage from EGR Cooler",
        status: "",
        apiOptionKey: "s4q5o2",
      },
      {
        label: "Found EGR cooler clogged",
        status: "",
        apiOptionKey: "s4q5o3",
      },
    ],
  },
  {
    label: "Intake Throttle Valve Condition",
    options: [
      { label: "Found ok", status: "", apiOptionKey: "s4q6o1" },
      {
        label: "Valve found struck",
        status: "",
        apiOptionKey: "s4q6o2",
      },
    ],
  },
  {
    label: "Blow-by Condition",
    options: [
      {
        label: "No Visible blowby gas",
        status: "",
        apiOptionKey: "s4q7o1",
      },
      {
        label: "Visible blowby gas observed",
        status: "",
        apiOptionKey: "s4q7o2",
      },
      {
        label: "Visible blowby gas observed with Oil traces in breather tube",
        status: "",
        apiOptionKey: "s4q7o3",
      },
      {
        label: "Visible blowby gas observed with Oil throw in breather tube",
        status: "",
        apiOptionKey: "s4q7o4",
      },
    ],
  },
  {
    label: "Blow-by Value in LPM",
    type: "INPUT",
    apiKey: "s4q8o1",
    options: [],
  },
];

export const AIR_FILTER_ACCORDION_TABS_QUESTIONS = {
  "Air Intake & Exhaust System": "",
  Aspiration: "",
};

export const isSelected = (details, question, option) => {
  const { apiKey = "", type = "" } = question;
  const { apiOptionKey, label } = option;

  if (question.type === "RADIO") {
    return details[apiKey] === option.label;
  }

  return details[apiOptionKey];
};

export const mappingDetailsToUI = (details) => {
  let withCoolerEngine = {};
  let withOutCoolerEngine = {};
  let naturalAspiration = {};

  if (details?.turboChargerType === "WITH_INTER_COOLER_ENGINE") {
    withCoolerEngine = details.turboCharger || {};
  }

  if (details?.turboChargerType === "WITHOUT_INTER_COOLER_ENGINE") {
    withOutCoolerEngine = details.turboCharger || {};
  }

  if (details?.turboChargerType === "NATURAL_ASPIRATION_ENGINES") {
    naturalAspiration = details.turboCharger || {};
  }

  const responseMapper = {
    airFilterType: details.airFilterType,
    turboChargerType: details.turboChargerType,
    lastOilChangeDateInWetAirFilterBowl:
      details.lastOilChangeDateInWetAirFilterBowl,
    //DRY
    foundDryAndClean: details?.conditionAirFilter?.foundDryAndClean,
    outerElementGotChocked: details?.conditionAirFilter?.outerElementGotChocked,
    innerElementGotChocked: details?.conditionAirFilter?.innerElementGotChocked,
    waterTracesObservedInFilterElement:
      details?.conditionAirFilter?.waterTracesObservedInFilterElement,
    oilTracesObservedInFilterElement:
      details?.conditionAirFilter?.oilTracesObservedInFilterElement,
    carbonSootObservedInFilterElement:
      details?.conditionAirFilter?.carbonSootObservedInFilterElement,
    outerElementFoundPunctured:
      details?.conditionAirFilter?.outerElementFoundPunctured,
    innerElementFoundPunctured:
      details?.conditionAirFilter?.innerElementFoundPunctured,
    attachments: details?.conditionAirFilter?.attachments,
    //WET
    noOilInWetFilterBowl: details?.conditionAirFilter?.noOilInWetFilterBowl,
    oilInBowlFoundContaminate:
      details?.conditionAirFilter?.oilInBowlFoundContaminate,
    oilLevelAndConditionFoundOk:
      details?.conditionAirFilter?.oilLevelAndConditionFoundOk,

    //S2 Q1
    s2q1o1: withCoolerEngine.airFilterToTurboChargerHoseCondition?.foundIntact,
    s2q1o2:
      withCoolerEngine.airFilterToTurboChargerHoseCondition
        ?.foundPunctureOrDamage,
    s2q1o3:
      withCoolerEngine.airFilterToTurboChargerHoseCondition?.foundClampLoose,
    //S2 Q2
    s2q2o1:
      withCoolerEngine.turboChargerToInterCoolerHoseCondition?.foundIntact,
    s2q2o2:
      withCoolerEngine.turboChargerToInterCoolerHoseCondition
        ?.foundPunctureOrDamage,
    s2q2o3:
      withCoolerEngine.turboChargerToInterCoolerHoseCondition?.foundClampLoose,

    //S2 Q3
    s2q3o1:
      withCoolerEngine.interCoolerToInletManidoldHoseCondition?.foundIntact,
    s2q3o2:
      withCoolerEngine.interCoolerToInletManidoldHoseCondition
        ?.foundPunctureOrDamage,
    s2q3o3:
      withCoolerEngine.interCoolerToInletManidoldHoseCondition?.foundClampLoose,

    //S2 Q4
    foundOk: withCoolerEngine.conditionOfTurboCharger?.foundOk,
    s2q4o1:
      withCoolerEngine.conditionOfTurboCharger?.foundCompressorWheelFinsDamaged,
    s2q4o2:
      withCoolerEngine.conditionOfTurboCharger?.foundTurbineWheelFinsDamaged,
    s2q4o3: withCoolerEngine.conditionOfTurboCharger?.foundShaftBroken,
    s2q4o4:
      withCoolerEngine.conditionOfTurboCharger?.foundOilTracesInCompressorEnd,
    s2q4o5:
      withCoolerEngine.conditionOfTurboCharger?.foundOilTracesInTurbineEnd,
    //S2 Q5
    foundOkInterCooler: withCoolerEngine.conditionOfInterCooler?.foundOk,
    s2q5o1: withCoolerEngine.conditionOfInterCooler?.foundCoreDamaged,
    s2q5o2:
      withCoolerEngine.conditionOfInterCooler?.foundOilTracesInInterCooler,

    //S3 Q1
    s3q1o1:
      withOutCoolerEngine.airFilterToTurboChargerHoseCondition?.foundIntact,
    s3q1o2:
      withOutCoolerEngine.airFilterToTurboChargerHoseCondition
        ?.foundPunctureOrDamage,
    s3q1o3:
      withOutCoolerEngine.airFilterToTurboChargerHoseCondition?.foundClampLoose,
    //S3 Q2
    s3q2o1:
      withOutCoolerEngine.turboChargerToInletManifoldHoseCondition?.foundIntact,
    s3q2o2:
      withOutCoolerEngine.turboChargerToInletManifoldHoseCondition
        ?.foundPunctureOrDamage,
    s3q2o3:
      withOutCoolerEngine.turboChargerToInletManifoldHoseCondition
        ?.foundClampLoose,

    //S3 Q3
    s3q3o1: withOutCoolerEngine.conditionOfTurboCharger?.foundOk,
    s3q3o2:
      withOutCoolerEngine.conditionOfTurboCharger
        ?.foundCompressorWheelFinsDamaged,
    s3q3o3:
      withOutCoolerEngine.conditionOfTurboCharger?.foundTurbineWheelFinsDamaged,
    s3q3o4: withOutCoolerEngine.conditionOfTurboCharger?.foundShaftBroken,
    s3q3o5:
      withOutCoolerEngine.conditionOfTurboCharger
        ?.foundOilTracesInCompressorEnd,
    s3q3o6:
      withOutCoolerEngine.conditionOfTurboCharger?.foundOilTracesInTurbineEnd,

    // S4 Q1
    s4q1o1:
      naturalAspiration.airFilterToInletManifoldHoseCondition?.foundIntact,
    s4q1o2:
      naturalAspiration.airFilterToInletManifoldHoseCondition
        ?.foundPunctureOrDamage,
    s4q1o3:
      naturalAspiration.airFilterToInletManifoldHoseCondition?.foundClampLoose,

    // S4 Q2
    s4q2o1: details?.inExhaustSystem?.oilWetnessObservedInExhaustManifold,
    s4q2o2:
      details?.inExhaustSystem
        ?.noOilCoolantFuelTracesWetnessObservedInExhaustManifold,
    s4q2o3: details?.inExhaustSystem?.blockageInSilincerTilePipe,
    s4q2o4: details?.inExhaustSystem?.coolantTracesObservedInExhaustManifold,
    s4q2o5: details?.inExhaustSystem?.unburntFuelComingOutFromExhaustManifold,
    s4q2o6: details?.inExhaustSystem?.blockageObservedInDOC,
    s4q2o7: details?.inExhaustSystem?.blockageInDPF,

    // S4 Q3
    s4q3o1: details?.inIntakeSystemSchema?.oilWetnessObservedInInletManifold,
    s4q3o2:
      details?.inIntakeSystemSchema
        ?.noOilCoolantFuelTracesWetnessObservedInInletManifold,
    s4q3o3: details?.inIntakeSystemSchema?.carbonSootObservedInInletManifold,
    s4q3o4: details?.inIntakeSystemSchema?.coolantTracesObservedInInletManifold,
    s4q3o5: details?.inIntakeSystemSchema?.dustObservedInInletManifold,

    // S4 Q4
    s4q4o1: details?.egrCondition?.foundOk,
    s4q4o2: details?.egrCondition?.egrValveFoundStruck,

    //S4 Q5
    s4q5o1: details?.egrCoolerCondition?.foundOk,
    s4q5o2: details?.egrCoolerCondition?.foundCoolantLeakageFromEGRCodoler,
    s4q5o3: details?.egrCoolerCondition?.foundEGRCoolerClogged,

    //S4 Q6
    s4q6o1: details?.intakeThrottleValveCondition?.foundOkIntake,
    s4q6o2: details?.intakeThrottleValveCondition?.valveFoundStruck,

    //S4 Q7
    s4q7o1: details?.blowByCondition?.noVisibleBlowByGas,
    s4q7o2: details?.blowByCondition?.visibleBlowByGasObserved,
    s4q7o3:
      details?.blowByCondition
        ?.visibleBlowByGasObservedWithOilTracesInBreatherTube,
    s4q7o4:
      details?.blowByCondition
        ?.visibleBlowByGasObservedWithOilThrowInBreatherTube,

    s4q8o1: details.blowByValueInLPM,
  };

  return responseMapper;
};
